import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./TravelArrangementsSideCards.css";

const TravelArrangementsSideCards = () => {
  return (
    <>
      <div className="container safetyCardContainer">
        <div className="safetyCardBox my-md-5  px-md-4 my-5">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h1 className="headings mt-md-4 mt-lg-2  safetyCardHeading ps-md-0">
              <span>Customized</span> Travel Safety for Every Journey
            </h1>
            <p className="side-card-p my-lg-4 mt-lg-4 mt-md-2 ps-md-0 travelarrangecardsPara">
              At Blueberry Travels, we understand that no two travelers are
              alike. Whatever travel option you choose, whether a business trip,
              a family vacation, or a sports adventure, we offer customized
              safety solutions that meet the unique needs of travelers.
              <br />
              <p className="mt-2">
                From solo explorers to large groups, our approach assures your
                security and comfort while matching perfectly with your goals
                and travel requirements. We even recognize the importance of
                personalized attention, which is why we create travel safety
                plans that adapt to your destination, the motive of your trip,
                and any special conditions.
              </p>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-md-2 mt-lg-0 d-md-flex justify-content-md-center ms-md-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/taSide1.png"
              alt=""
              className="safetyTravelimg"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBoxReverse my-md-5  px-md-4 my-5">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h1 className="headings mt-md-5 safetyCardHeading  ps-md-0">
              <span>Travel</span> with Pride
            </h1>
            <p className="side-card-p my-lg-3 mt-lg-4 mt-md-2  ps-md-0 travelarrangecardsPara">
              We believe that a truly memorable journey starts with a solid
              foundation of safety and security. And here, Blueberry Travels
              assures you to be a part of this journey! We’re committed to
              providing comprehensive safety measures that ensure your peace of
              mind.
              <br />
              <p className="mt-2">
                {" "}
                We take our responsibility for your well-being seriously,
                offering a range of travel safety resources that allow you to
                explore the world without sacrificing your productivity. Whether
                you’re seeking 24/7 support, real-time alerts, or clear
                communication regarding health protocols, count on us and we
                ensure your safety is never compromised.
              </p>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-md-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/sidecard2.png"
              alt=""
              className="safetyTravelimg safetyTravelimg2"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBox  my-md-5  px-md-4 my-5">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h1 className="headings mt-md-5 pt-md-3  safetyCardHeading  ps-md-0">
              <span>Real-Time Tracking</span> and Emergency Assistance
            </h1>
            <p className="side-card-p my-lg-3 mt-lg-4 mt-md-2  ps-md-0 travelarrangecardsPara">
              Blueberry Travel offers full visibility into your travel details.
              Our traveler map allows travel managers to track all travelers’
              locations and associated risks while traveling, ensuring complete
              safety oversight. While in case of emergencies, our dedicated
              customer care team is available around the clock to provide
              immediate support, ensuring quick responses and peacefulness
              throughout your journey.
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 travelarrangementimg mt-4 mt-lg-0 d-md-flex justify-content-md-center ms-md-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/sidecard3.png"
              alt=""
              className="safetyTravelimg"
              loading="lazy"
            />
          </div>
        </div>

        <div className="safetyCardBoxReverse my-md-5 my-5 px-md-4 ">
          <div className="col-lg-6 col-md-6 col-sm-12">
            <h1 className="headings mt-lg-5 mt-md-4 pt-md-2 pt-lg-0  safetyCardHeading  ps-md-0">
              <span>Cultural </span>Insights for Enhanced Safety
            </h1>
            <p className="side-card-p my-lg-3 mt-lg-4 mt-md-2  ps-md-0 travelarrangecardsPara">
              Safety goes beyond just health and security! We believe it’s more
              about understanding and respecting the diverse cultures you
              experience. Blueberry Travel provides key insights into local
              customs and etiquette, helping you navigate cultural nuances
              safely and respectfully.
              <br />
              <p className="mt-2">
                Meanwhile, by embracing cultural awareness, we empower you to
                promote meaningful, respectful connections while ensuring that
                your journey aligns with both your safety and global harmony.
              </p>
            </p>
          </div>

          <div className="col-lg-6 col-md-6 col-sm-12 mt-4 mt-md-4 mt-lg-0 travelarrangementimg d-md-flex justify-content-md-center me-md-5">
            <LazyLoadImage
              src="https://blueberrywebsites.azureedge.net/bbt/images/sidecard4.png"
              alt=""
              className="safetyTravelimg safetyTravelimg2"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default TravelArrangementsSideCards;
